// Accept whatever a non-technical editor pastes — a full watch URL, a share
// link, an embed URL, a Shorts link, or a bare 11-char ID — and return the
// video ID. Falls back to the trimmed input so a wrong paste is visibly
// "unavailable" rather than silently dropped.
export function extractYouTubeId(input: string): string {
  const s = (input || '').trim();
  if (!s) return '';
  const patterns = [
    /[?&]v=([A-Za-z0-9_-]{11})/,
    /youtu\.be\/([A-Za-z0-9_-]{11})/,
    /youtube\.com\/embed\/([A-Za-z0-9_-]{11})/,
    /youtube\.com\/shorts\/([A-Za-z0-9_-]{11})/,
  ];
  for (const re of patterns) {
    const m = s.match(re);
    if (m) return m[1];
  }
  if (/^[A-Za-z0-9_-]{11}$/.test(s)) return s;
  return s;
}
